import type { RouteRecordRaw } from 'vue-router'

import { descriptorsSEO } from '@/constants/descriptorsSEO'
import DescriptorPage from '@/pages/DescriptorPage.vue'

const descriptors = Object.keys(descriptorsSEO)

const mappedRoutes: RouteRecordRaw[] = descriptors.map((descriptor) => ({
  path: `/${descriptor}`,
  component: DescriptorPage,
  meta: {
    descriptor,
  },
}))

const indexRoute: RouteRecordRaw = {
  path: '/',
  component: DescriptorPage,
  meta: {
    descriptor: '',
  },
}

export const routes = [...mappedRoutes, indexRoute]

// Vite removes these routes and their imports from every production build.
if (import.meta.env.DEV) {
  routes.unshift({
    path: '/preview',
    redirect: `/preview/${import.meta.env.VITE_TEMPLATE_ID}/${descriptors[0]}`,
  }, {
    path: '/preview/:templateId/:descriptor',
    component: () => import('@/preview/PreviewPage.vue'),
    meta: { descriptor: '' },
  })
}
